<template>
    <!--begin::Dashboard-->


    <main class="main">
        <div class="cloudsTop"></div>
        <div class='container'>
            <!-- HOME -->
            <section class="home section mt-20" id="home">
<!--              &lt;!&ndash; Arabic version &ndash;&gt;-->
<!--              <slide v-if="i18n.locale.value === 'ar'" :key="1">-->
<!--                <a href="https://register.nta.eg/all-programs/show_program/683453aa82eb153511939a42">-->
<!--                  <img-->
<!--                    class="container-fluid w-1600px"-->
<!--                    :src="require('@/assets/images/interns-ar.png')"-->
<!--                  />-->
<!--                </a>-->
<!--              </slide>-->

<!--              &lt;!&ndash; English and other languages version &ndash;&gt;-->
<!--              <slide v-else :key="2">-->
<!--                <a href="https://register.nta.eg/all-programs/show_program/683453aa82eb153511939a42">-->
<!--                  <img-->
<!--                    class="container-fluid w-1600px"-->
<!--                    :src="require('@/assets/images/interns-en.png')"-->
<!--                  />-->
<!--                </a>-->
<!--              </slide>-->


                <div class="home_container pt-20 grid container">
                  <div class="col-md-12">
                    <div class="alert bg-danger">
                      <h4 class="text-white text-center">
                        <i class="uil uil-document-info text-white"></i>
                        "{{$t('programs_hint')}}"</h4>
                    </div>
                  </div>
                    <div class="home_content grid">
                        <div class="home_social ">
                            <!-- Links to social media -->
                            <!--<a href="https://www.linkedin.com/school/ntaegy" class="home_social-icon" target="_blank"><i-->
                            <!--class="uil uil-linkedin-alt"></i></a>-->
                            <!--<a href="https://twitter.com/NTAEgy" class="home_social-icon" target="_blank"><i-->
                            <!--class="uil uil-twitter"></i></a>-->
                            <!--<a href="https://www.instagram.com/ntaegy/" class="home_social-icon" target="_blank"><i-->
                            <!--class="uil uil-instagram" target="_blank"></i></a>-->
                        </div>

                        <div class="home_img">
                            <client-only>
                                <Vue3Lottie
                                        animationLink="https://assets10.lottiefiles.com/packages/lf20_gysrp57x.json"
                                />
                            </client-only>
                            <br><br><br>
                        </div>
                        <div class="home_data">

                            <carousel :autoplay="5000" :loop="true" :infinite="true" :itemsToShow="1" class="mb-4">
                                <slide :key="0">
                                    <div class="carousel__item text-start p-5 w-100">
                                        <h3 class="home_title">{{$t('mission')}}</h3>
                                        <p class="home_description">
                                            {{$t('mission_text')}}
                                        </p>
                                    </div>
                                </slide>


                                <template #addons>
                                    <pagination/>
                                </template>
                            </carousel>
                            <!--<h1 class="home_title">{{$t('nta_text')}}</h1>-->
                            <!--<h3 class="home_subtitle">{{$t('vision')}}</h3>-->
                        </div>
                    </div>
                </div>
              <div class="mt-2  text-start d-flex justify-content-center">
                <a v-if="i18n.locale.value =='ar'" href="https://nta.eg/ar-faq.html" target="_blank" class="btn btn-dark">
                  <i class="uil uil-comments text-white button_icon"></i>
                  {{$t('p1')}}
                </a>
                <a v-else href="https://nta.eg/faq.html" target="_blank" class="btn btn-dark">
                  <i class="uil uil-comments text-white button_icon"></i>
                  {{$t('p1')}}
                </a>
                &nbsp;&nbsp;&nbsp;
                <a href="javascript:void(0)" @click="scrollTo()" class="btn btn-danger">
                  <i class="uil uil-video text-white button_icon"></i>
                  {{$t('p2')}}
                </a>
              </div>
              <br><br>
            </section>

        </div>

<!--      <input type="file" class="form-control"-->
<!--             @change='handleChangeImage($event)'>-->
        <section class="section mt-20 mb-0" style="background: linear-gradient(180deg,#f5f8fa,#fff,#fff)">
            <div class="container-fluid text-center">
                <div class="row justify-content-center">
                    <div class="col-md-3 text-start">
                        <h1 class="mb-5 mt-5 text-danger">{{$t('video_header')}}</h1>
                        <p class="mb-5 fw-bolder text-dark">{{$t('video_hint')}}</p>
                    </div>
                    <div class="col-md-4">
                        <div class="card" style="border-radius: 40px;overflow: hidden" id="video_portal">
                            <iframe width="100%" height="415"
                                    src="https://www.youtube.com/embed/iJQrSi2H_b0?si=UrQ4O_vUf60zmS-c"
                                    title="YouTube video player" frameborder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                    allowfullscreen></iframe>
                        </div>
                    </div>
                    <div class="col-md-8">
                        <div class="text-start mt-5">
                            <img :src="require('@/assets/images/DottedSquare.png')" class="w-200px" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!--<section class="bg-white section">-->
            <!--<div class="container">-->
                <!--<div class="row">-->
                    <!--<div class="col-12">-->
                        <!--<Events/>-->
                    <!--</div>-->
                <!--</div>-->
            <!--</div>-->
        <!--</section>-->
        <!--<section class="bg-light section">-->
        <!--<div class="text-center">-->
        <!--<h2 class="mb-5 text-danger">{{$t('download_app')}}</h2>-->
        <!--<a href="">-->
        <!--<img :src="require('@/assets/images/android.png')" class="w-175px" alt="">-->
        <!--</a>-->
        <!--&nbsp;-->
        <!--<a href="">-->
        <!--<img :src="require('@/assets/images/ios.png')" class="w-175px" alt="">-->
        <!--</a>-->
        <!--</div>-->
        <!--</section>-->
        <!--<section class="bg-white section">-->
        <!--<div class="container">-->
        <!--<div class="row">-->
        <!--<div class="col-12">-->
        <!--<News/>-->
        <!--</div>-->
        <!--</div>-->
        <!--</div>-->
        <!--</section>-->

    </main>
    <!--end::Dashboard-->
</template>

<script lang="ts">
import { defineComponent, inject, onMounted } from "vue";
  import { useRoute, useRouter } from 'vue-router';
  import { useStore } from 'vuex';
import {useI18n} from 'vue-i18n';
  import 'vue3-carousel/dist/carousel.css';
  import { Carousel, Slide, Pagination, Navigation } from 'vue3-carousel';
  import News from '@/components/home/News.vue';
  import Events from '@/components/home/Events.vue';

  export default defineComponent({
    name: 'dashboard',
    components: {
      News,
      Events,
      Carousel,
      Slide,
      Pagination,
      Navigation,
    },
    methods:{
      scrollTo(){
       let video_portal:any =  document.getElementById("video_portal");
       if (video_portal) {
         window.scrollTo({
           top: video_portal.scrollHeight + 200,
           behavior: 'smooth'
         })
       }
      }
    },
    setup() {
      const router = useRouter();
      const store = useStore();
      const i18n = useI18n();
      const helpers: any = inject('helpers');
      // const handleChangeImage = (evt: Event | any)=>{
      //   let file = evt.target.files[0];
      //   helpers.OptimizeImage(file).then((R)=>{
      //     console.log(R,(R.originalFile.size/1024).toFixed(2) + " KB",(R.compressFile.size/1024).toFixed(2) + " KB")
      //   })
      // }

      return {
        store,
        i18n,
        // handleChangeImage
      };
    },
  });
</script>
<style scoped>

    .carousel__item {
        min-height: 150px;
        width: 100%;
        margin: 10px;
    }

    .carousel__slide {
        padding: 0;
    }

</style>
